// extracted by mini-css-extract-plugin
export default {"seven":"screen_seven__f7x+f"};